module.exports = __webpack_public_path__ + "img/carrousel-flatpanel-18.d69dbc29.png";